<template>
	<div class="shop-index">
		<Search :renderData="renderData" :formData="form" :unfold="true" @onSearch="onSearch"></Search>
		<div class="fun-btn-box">
			<auth-button auth="finance:store:create">
				<el-button type="primary" class="mr10" @click="onAdd">+ 录入店铺</el-button>
			</auth-button>
			<el-button class="mr10" @click="onBatchImport">批量导入</el-button>
			<auth-button auth="finance:store:storecard:download">
				<el-button class="mr10" :loading="exportLoading1" @click="onExport('cardBuyRecord')">购卡记录导出</el-button>
			</auth-button>
			<auth-button auth="finance:store:storecard:download">
				<el-button class="mr10" :loading="exportLoading2" @click="onExport('cardScanCode')">储值卡推广码导出</el-button>
			</auth-button>
		</div>
		<Table ref="table" :tableThData="tableThData" :tableTrData="tableTrData" :loading="loading" :limit="limit"
			:offset="offset" :total="total" v-on:handleSizeChange="handleSizeChange"
			v-on:handleCurrentChange="handleCurrentChange" :selection="true" @selectTable="selectTable"
			@selectTable_all="selectTable_all">
			<template #id="{ row }">{{ row.id }}</template>
			<template #name="{ scope }">
				<auth-button auth="finance:store:detail" :elseInfo="scope.row.name">
					<el-button @click="onDetail(scope.row)" type="text"
						class="store-name">{{scope.row.name}}</el-button>
				</auth-button>
			</template>
			<template #code="{ row }">{{ row.code }}</template>
			<template #refId="{ row }">{{ row.refId }}</template>
			<template #mallName="{ row }">{{ row.mallName }}</template>
			<template #floor="{ row }">{{ row.floor }}</template>
			<template #category="{ row }">{{ row.category }}</template>
			<template #brandName="{ row }">{{ row.brandName?row.brandName:'---' }}</template>
			<template #disable="{ row }">{{ row.disable ? '已关店' : '营业' }}</template>
			<template #contractorPhone="{ row, scope }">
				<span :key="tableKey">{{ row.contractorPhone_show || row.contractorPhone }}</span>
				<auth-button auth="user:phone:read">
					<el-button v-if="row.contractorPhone" class="look-phone-btn" type="text"
						@click="onLookPhone(row, scope.$index)">
						{{ row.contractorPhone_show ? '隐藏' : '查看' }}
					</el-button>
				</auth-button>
			</template>
			<template
				#created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
			<template #operatorName="{ row }">{{ row.operatorName }}</template>
			<template #applicationStatus="{ row }">
				{{ row.applicationStatus ? row.applicationStatus : '未申请' }}
			</template>
			<template #operation="{ scope }">
				<auth-button auth="finance:ratio:create">
					<el-button type="text" v-if="!scope.row.disable" @click="goSetRate(scope.row)"
						class="mr10">设置费率</el-button>
				</auth-button>
				<auth-button auth="finance:store:detail">
					<el-button type="text" @click="onDetail(scope.row)" class="mr10">查看详情</el-button>
				</auth-button>
				<br>
				<auth-button auth="finance:store:update" class="mr10">
					<el-button v-if="!scope.row.disable" type="text" class="error"
						@click="onChangeStatus(scope.row)">关闭店铺</el-button>
					<el-button v-if="scope.row.disable" type="text" @click="onChangeStatus(scope.row)">开启店铺</el-button>
				</auth-button>
				<el-button type="text"
					v-if="!scope.row.applicationStatus || scope.row.applicationStatus == '申请已驳回' || scope.row.applicationStatus == '入网申请资料有误'"
					@click="onRwApp(scope.row)">入网申请</el-button>
				<el-button type="text" v-if="scope.row.applicationStatus == '协议待签署'"
					@click="onShowXyqs(scope.row)">签署入网协议</el-button>
				<!-- <auth-button auth="store:payCode:download">
          <el-button type="text" @click="onDownCode(scope.row)">下载收款码</el-button>
        </auth-button> -->
			</template>
		</Table>
		<export-dialog :show="showExportDialog" @close="showExportDialog = false" :tableData="selectedData"
			:selectedIds="selectedIds" :type="exportType"></export-dialog>
	</div>
</template>

<script>
	import AuthButton from '@/components/AuthButton'
	import tableList from '@/mixins/tableList';
	import Search from "@/components/Search/index";
	import Table from "@/components/Table/index";
	import ExportDialog from "./components/exportDialog.vue";
	import {
		api_getShopList,
		api_getFloorData,
		api_getShopPhone,
		api_getDownloadCode,
		api_putChangeStatus,
		api_postStoredcardExport,
		api_postStoredVCCodeExport,
		networkAccessApp
	} from '@/api/finance'
	import {
		api_getConfig
	} from "@/api/common";
	import {
		downFile
	} from "@/utils";
	export default {
		name: "shopIndex",
		mixins: [tableList],
		components: {
			AuthButton,
			Search,
			Table,
			ExportDialog
		},
		data() {
			return {
				renderData: [{
						label: "选择店铺",
						placeholder: "请选择店铺名称",
						type: "choose-store",
						key: "ids",
					},
					{
						label: "店铺名称",
						placeholder: "请输入店铺名称",
						type: "input",
						key: "name",
					},
					{
						label: "商场名称",
						type: "mall",
						key: "mallIds",
					},
					{
						label: "运营状态",
						placeholder: "请选择运营状态",
						type: "select",
						key: "disable",
						option: [{
								label: '营业',
								value: 'false'
							},
							{
								label: '已关店',
								value: 'true'
							}
						]
					},
					{
						label: "楼层",
						placeholder: "请选择楼层",
						type: "select",
						key: "floor",
						option: [],
					},
				],
				form: {},
				tableKey: false,
				tableThData: [{
						prop: "id",
						label: "ID",
						minWidth: "60",
					},
					{
						prop: "name",
						label: "店铺名称",
						minWidth: "150",
					},
					{
						prop: "refId",
						label: "内部店铺编号",
						minWidth: "120",
					},
					{
						prop: "code",
						label: "外部店铺编号",
						minWidth: "120",
					},
					{
						prop: "mallName",
						label: "商场名称",
						minWidth: "120",
					},
					{
						prop: "brandName",
						label: "所属品牌",
						minWidth: "140",
					},
					{
						prop: "floor",
						label: "店铺楼层",
						minWidth: "100",
					},
					{
						prop: "category",
						label: "所属业态",
						minWidth: "120",
					},
					{
						prop: "disable",
						label: "运营状态",
						minWidth: "100",
					},
					{
						prop: "contractorPhone",
						label: "联系电话",
						minWidth: "160",
					},
					{
						prop: "created",
						label: "创建时间",
						minWidth: "180",
					},
					{
						prop: "operatorName",
						label: "操作人",
						minWidth: "100",
					},
					{
						prop: "applicationStatus",
						label: "入网状态",
						minWidth: "100",
					},
					{
						prop: "operation",
						label: "操作",
						minWidth: "200",
					},
				],
				exportLoading1: false,
				exportLoading2: false,
				selectedIds: [],
				selectedData: [],
				exportType: '',
				showExportDialog: false,
			};
		},
		created() {
			this.getShopFloorData() // 获取楼层
		},
		methods: {
			onRwApp(r) {
				const loading = this.$loading({
					lock: true,
					text: '申请中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				networkAccessApp(r.id).then(_ => {
					loading.close();
					console.log('申请返回', _)
					if (_.data == '请求成功') {
						this.$message.success(_.data)
					} else {
						this.$message.error(_.data)
					}
				}).catch(err => {
					loading.close();
					this.$message.error(err)
				})
			},
			onShowXyqs(r) {
				if (r.applicationPdf) {
					window.open(r.applicationPdf)
				} else {
					this.$message.error('签署协议地址无效！')
				}
			},
			// 禁用选项
			checkSelectable_all(row) {
				return true
			},
			getSelectData(selection) {
				this.selection = selection
			},
			//获取楼层下拉框数据
			async getShopFloorData() {
				const res = await api_getFloorData()
				const newRes = res.floors.split(',').map(item => {
					return {
						label: item,
						value: item
					}
				})
				const index = this.renderData.findIndex(item => item.key == 'floor')
				this.renderData[index].option = newRes
			},

			// 获取表格列表数据
			async getList() {
				this.loading = true
				const params = {
					...this.form,
					offset: this.offset,
					limit: this.limit,
				}
				this.$router.push({
					query: params
				})
				try {
					const data = await api_getShopList(params)
					console.log('data: ', data);
					this.tableTrData = data.list
					this.total = data.count
					this.loading = false
				} catch {
					this.loading = false
				}
				this.handleEchoSelect() // 回显选中项
			},

			// 点击查看手机号
			async onLookPhone(row, index) {
				if (row.contractorPhone_show) {
					delete this.tableTrData[index].contractorPhone_show
				} else {
					const res = await api_getShopPhone({
						storeId: row.id
					})
					this.tableTrData[index].contractorPhone_show = res.contractorPhone
				}
				this.tableKey = !this.tableKey
			},

			// 点击录入按钮
			onAdd() {
				this.$router.push("/financeShop/index/add");
			},

			// 点击查看详情按钮
			onDetail(row) {
				this.$router.push(`/financeShop/index/detail?id=${row.id}`);
			},

			// 设置费率
			goSetRate(row) {
				this.$router.push({
					path: `/financeShop/index/setRate?id=${row.id}`
				})
			},

			// 点击表格启用、禁用
			onChangeStatus(row) {
				let newRow = JSON.parse(JSON.stringify(row))
				newRow.disable = !row.disable
				this.$baseConfirm(
					row.disable ? '是否确认开启该店铺？' : '是否确认关闭该店铺？', {
						title: '提示',
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						showClose: false,
						type: 'warning',
					},
					async () => {
						this.updateItem(newRow, () => {
							row.disable = newRow.disable
						})
					}
				)
			},

			// 更新数据
			async updateItem(row, cb) {
				await api_putChangeStatus({
					id: row.id
				})
				this.$baseMessage('操作成功', 'success')
				this.getList()
				cb()
			},

			// 点击下载收款码
			async onDownCode(row) {
				let loading = this.$baseLoading(6)
				try {
					const res = await api_getDownloadCode({
						id: row.id
					})
					const url = window.URL.createObjectURL(new Blob([res.data]))
					let fileName = res.headers['content-disposition'].split('filename=')[1]
					fileName = decodeURI(fileName)
					const link = document.createElement('a')
					link.target = '_blank'
					link.href = url
					link.setAttribute('download', fileName)
					link.click()
				} catch (err) {
					this.$baseMessage('下载失败', 'error')
					console.log('err: ', err);
				}
				loading.close()
			},

			// 禁用选项
			checkSelectable_all(row) {
				return true
			},
			// 回显选中项
			handleEchoSelect() {
				this.loading = true
				let selectRow = this.tableTrData.filter(item => this.selectedIds.indexOf(item.id) >= 0)
				setTimeout(() => {
					for (let i = 0; i < selectRow.length; i++) {
						this.$refs.table.$refs.myTable.toggleRowSelection(selectRow[i], true);
					}
					this.loading = false
				}, 100)
			},
			// 表格单选选择
			selectTable(selection, row) {
				let curRowIndex = selection.findIndex(item => item.id == row.id)
				if (curRowIndex >= 0) {
					// 选择
					this.selectedData.push(row)
				} else {
					// 取消选择
					this.selectedData = this.selectedData.filter(item => item.id !== row.id)
				}
				this.selectedIds = this.selectedData.map(item => item.id)
			},

			// 表格全选选择
			selectTable_all(selection) {
				console.log('selection: ', selection);
				if (selection.length) {
					// 全选
					let curRow = this.tableTrData.filter(item => this.selectedIds.indexOf(item.id) < 0)
					this.selectedData = [...this.selectedData, ...curRow]
				} else {
					// 取消全选
					let curTableIds = this.tableTrData.map(item => item.id)
					this.selectedData = this.selectedData.filter(item => curTableIds.indexOf(item.id) < 0)
				}
				this.selectedIds = this.selectedData.map(item => item.id)
			},

			// 导出
			async onExport(type) {
				if (!this.selectedIds.length) {
					this.$baseMessage('请选择需要导出的数据', 'error')
					return
				}
				this.exportType = type
				this.showExportDialog = true
			},

			// 批量导入
			onBatchImport() {
				this.$router.push({
					path: `/financeShop/index/import`
				})
			}
		},
		computed: {},
	};
</script>
<style lang="scss" scoped>
	.shop-index {
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;

		.look-phone-btn {
			font-size: 10px;
			color: #3775FF;
			margin-left: 5px;
		}

		.fun-btn-box {
			margin-top: 20px;
		}

		.store-name {
			height: auto;
			white-space: normal;
		}
	}
</style>